<template>
  <b-dropdown-form
    class="py-1 dropdown-filter-form-n"
  >
    <b-row>
      <b-col cols="10">
        <p>Filters</p>
      </b-col>
      <b-col cols="2">
        <feather-icon
          icon="XIcon"
          size="16"
          class="align-right"
          @click="$emit('emitHideFilter')"
        />
      </b-col>
    </b-row>
    <b-form-group label="Type of Promotion">
      <b-form-checkbox
        v-for="option in typeOptions"
        :key="option.code"
        v-model="typeFilterValue"
        :value="option.code"
        name="promotion-type-filter"
      >
        {{ option.title }}
      </b-form-checkbox>
    </b-form-group>
    <b-form-group label="Status">
      <b-form-checkbox
        v-for="option in statusOptions"
        :key="option.code"
        v-model="statusFilterValue"
        :value="option.code"
        name="promotion-status-filter"
      >
        {{ option.title }}
      </b-form-checkbox>
    </b-form-group>
    <div class="d-flex mt-1">
      <b-button
        variant="outline-primary"
        size="md"
        class="mr-1 w-100"
        @click="clearFilter"
      >
        Clear All
      </b-button>
      <b-button
        variant="primary"
        size="md"
        class="w-100"
        @click="applyFilter"
      >
        Apply Filter
      </b-button>
    </div>
  </b-dropdown-form>
</template>

<script>
import {
  BDropdownForm, BFormGroup, BButton, BRow, BCol, BFormCheckbox,
} from 'bootstrap-vue'

export default {
  components: {
    BButton,
    BDropdownForm,
    BFormGroup,
    BRow,
    BCol,
    BFormCheckbox,
  },
  props: {
    type: {
      type: [Array, null],
      default: null,
    },
    typeOptions: {
      type: Array,
      required: true,
    },
    status: {
      type: [Array, null],
      default: null,
    },
    statusOptions: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      typeFilterValue: JSON.parse(JSON.stringify(this.type)) || [],
      statusFilterValue: JSON.parse(JSON.stringify(this.status)) || [],
    }
  },
  watch: {
    type: {
      immediate: true,
      handler(val) {
        this.typeFilterValue = JSON.parse(JSON.stringify(val)) || []
      },
    },
    status: {
      immediate: true,
      handler(val) {
        this.statusFilterValue = JSON.parse(JSON.stringify(val)) || []
      },
    },
  },
  methods: {
    applyFilter() {
      this.$emit('update:type', this.typeFilterValue)
      this.$emit('update:status', this.statusFilterValue)

      this.$emit('emitHideFilter')
    },
    clearFilter() {
      this.typeFilterValue = []
      this.statusFilterValue = []

      this.$emit('update:type', this.typeFilterValue)
      this.$emit('update:status', this.statusFilterValue)

      this.$emit('emitHideFilter')
    },
  },
}
</script>
